import { MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useUser } from '../../../../api/useAuth';
import { ROLES } from '../../../../utils/constants';

type NameAndEmail = {
    name: string;
    email: string;
}
type ClientAndRelativesEmailSelectionFieldProps = {
    entityForm: UseFormReturn;
    client: NameAndEmail;
    relatives: Array<NameAndEmail>;
};

export const ClientAndRelativesEmailSelectionField = ({entityForm, client, relatives}: ClientAndRelativesEmailSelectionFieldProps) => {
    const { data: user } = useUser();
    const isTechAdmin = user?.role?.id === ROLES.tech_admin;
    const emails = possibleEmails(client, relatives);
    if (isTechAdmin) emails.push(DEBUG_EMAIL);
    
  return (
    <Controller
    name="emailData"
    control={entityForm.control}
    render={({ field }) => {
        const selectedEmailId = field.value?.id || "";

        return (
            <FormControl fullWidth>
                <InputLabel>Email para enviar o documento</InputLabel>
                <Select
                    {...field}
                    value={selectedEmailId}
                    onChange={(e: any) => {
                        const selectedEmail = emails.find((email) => email.id === e.target.value);
                        const newEmailData = {
                            id: selectedEmail?.id || "",
                            name: selectedEmail?.name?.split(" ")?.[0] || "",
                            email: selectedEmail?.email || "",
                        };
                        field.onChange(newEmailData);
                    }}
                    label="Email para enviar o documento"
                >
                    {emails &&
                        emails.map((email: Email) => (
                            <MenuItem key={email.id} value={email.id}>
                                {email.name} | {email.email} ({email.type === "relative" ? "Parente" : email.type === "debug" ? "Debug" : "Cliente"})
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
        );
    }}
    />
  );
};


type Email = {
    type: "client" | "relative" | "debug"
    email: string,
    name: string,
    id: string
}

const DEBUG_EMAIL: Email = {
    type: "debug",
    email: "ricardolinhares.dev@gmail.com",
    name: "debug",
    id: "debug-ricardolinhares.dev@gmail.com",
};
const possibleEmails = (client: NameAndEmail, relatives?: Array<NameAndEmail>): Array<Email> => {
    if (!client) return [];

    const possibleEmails: Array<Email> = [
        {
            type: "client",
            email: client.email,
            name: client.name,
            id: `${client.email}-${client.name}`
            
        },
    ];
    if (relatives && relatives?.length > 0) {
        relatives.forEach((relative: NameAndEmail) => {
            possibleEmails.push({
                type: "relative",
                email: relative.email,
                name: relative.name,
                id: `${relative.email}-${relative.name}`
            });
        });
    }
    return possibleEmails;
};